<div class="dashboard-views-table-details-info" >
    <div class="project-summary-features">
        <project-details-info-features></project-details-info-features>
    </div>
    <div class="project-summary-details box_default box_white">
        <project-details-info-details></project-details-info-details>
    </div>
</div>
